import { makeStyles } from '@mui/styles'
import React from 'react'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  leftButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  rightButton: {
    display: 'flex',
    alignItems: 'center'
  }
}))

interface DispatchOtButtonBarProps {
  onDeclareError: () => void
  onPrintManifest: () => void
  onDispatch: () => void
  disabled?: boolean
  hasWorkOrder?: boolean
}

export const DispatchOtButtonBar: React.FC<DispatchOtButtonBarProps> = ({
  onDeclareError,
  onPrintManifest,
  onDispatch,
  disabled = false,
  hasWorkOrder = false
}) => {
  const classes = useStyles()

  return (
    <div className={classes.buttonContainer}>
      <div className={classes.leftButtons}>
        <Button
          variant='contained'
          color='primary'
          onClick={onPrintManifest}
          disabled={disabled || !hasWorkOrder}
        >
          Imprimir manifiesto
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={onDeclareError}
          disabled={disabled}
        >
          Declarar Error
        </Button>
      </div>

      <div className={classes.rightButton}>
        <Button
          variant='contained'
          color='primary'
          onClick={onDispatch}
          disabled={disabled || !hasWorkOrder}
        >
          Despachar
        </Button>
      </div>
    </div>
  )
}
